// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { WorkflowModes } from "services/WorkflowModes/WorkflowModes";
export class TechnicalTroubleshootingGuidanceCatalog {
    static TechnicalTroubleshootingOverviewModule: IGuidanceTopic = {
        name: "TechnicalTroubleshooting_Overview",
        modulePath: PLATFORM.moduleName("guidance/TechnicalTroubleshooting/Overview.html"),
        title: "Technical Troubleshooting",
        moduleType: WorkflowModuleType.Help,

        topicType: GuidanceTopicType.TopicOverview,
        topicContent: "Technical Troubleshooting",
    };

    static TechnicalTroubleshootingGS1Module: IGuidanceTopic = {
        name: "TechnicalTroubleshooting_Q1", // https://sorama.atlassian.net/wiki/spaces/UI/pages/716079263/TT1+What+do+the+colors+of+the+LED+light+on+the+camera+mean
        modulePath: PLATFORM.moduleName("guidance/TechnicalTroubleshooting/TT1ColorsOfLedLightCamera.html"),
        title: "Technical Troubleshooting",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canUseCAM64AndCAM1K),
        topicParent: TechnicalTroubleshootingGuidanceCatalog.TechnicalTroubleshootingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What do the colors of the LED light on the camera mean?",
        catchwords: [""],
    };

    static TechnicalTroubleshootingGS2Module: IGuidanceTopic = {
        name: "TechnicalTroubleshooting_Q2", //https://sorama.atlassian.net/wiki/spaces/UI/pages/825491534/TT2+Any+troubles+with+connection+to+the+Sorama+Acquisition+Service
        modulePath: PLATFORM.moduleName("guidance/TechnicalTroubleshooting/TT2ClientTroubleshoot.html"),
        title: "Service Troubleshooting",
        moduleType: WorkflowModuleType.Help,
        topicType: GuidanceTopicType.Question,
        topicParent: TechnicalTroubleshootingGuidanceCatalog.TechnicalTroubleshootingOverviewModule,
        topicContent: "Service Troubleshooting",
    };

    static TechnicalTroubleshootingGS2FirefoxModule: IGuidanceTopic = {
        name: "TechnicalTroubleshooting_Q2Firefox",
        modulePath: PLATFORM.moduleName("guidance/TechnicalTroubleshooting/TT2ClientTroubleshootFirefox.html"),
        title: "Browser Troubleshooting (Firefox)",
        moduleType: WorkflowModuleType.Help,
        topicType: GuidanceTopicType.Question,
        topicParent: TechnicalTroubleshootingGuidanceCatalog.TechnicalTroubleshootingOverviewModule,
        topicContent: "Browser Troubleshooting (Firefox)",
    };

    static TechnicalTroubleshootingGS3Module: IGuidanceTopic = {
        name: "TechnicalTroubleshooting_Q3", //https://sorama.atlassian.net/wiki/spaces/UI/pages/825426037/TT3+What+is+a+Motion+Device
        modulePath: PLATFORM.moduleName("guidance/TechnicalTroubleshooting/TT3WhatIsAMotionDevice.html"),
        title: "Motion Device",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canUseCAM64AndCAM1K),
        topicParent: TechnicalTroubleshootingGuidanceCatalog.TechnicalTroubleshootingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is a Motion Device?",
    };

    static TechnicalTroubleshootingGS4Module: IGuidanceTopic = {
        name: "TechnicalTroubleshooting_Q4", //https://sorama.atlassian.net/wiki/spaces/UI/pages/825360545/TT4+Why+is+my+Sound+Camera+and+or+Video+Camera+not+listed
        modulePath: PLATFORM.moduleName("guidance/TechnicalTroubleshooting/TT4WhyIsMyDeviceNotListed.html"),
        title: "Sorama Devices",
        moduleType: WorkflowModuleType.Help,
        topicParent: TechnicalTroubleshootingGuidanceCatalog.TechnicalTroubleshootingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "Why is my device not listed?",
    };
}
